/* eslint-disable quotes */
/**
 * Redux Store Configuration
 * 
 * Configures the central Redux store with all application slices:
 * - info: Global UI state, loader, toasts, alerts, theme
 * - customer: User authentication and profile
 * - cafe: Home screen data (ads, canteens, recommended items)
 * - cart: Multi-canteen shopping cart state
 * - orders: Order list with pagination
 * - orderDetails: Single order detail view
 * - canteen: Restaurant menu (categories, items, slots)
 * - bluetoothPrinter: Bluetooth printer settings (Android)
 * - thermalPrinters: Thermal printer settings (Electron desktop)
 * 
 * Uses redux-thunk middleware for async actions
 * 
 * @module store
 */
import { configureStore, Tuple } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';

import { combineReducers } from "redux";
import info from "./info.slice";
import customer from "./customer.slice";
import cafe from "./cafe.slice";
import cart from "./cart.slice";
import orders from "./orders.slice";
import orderDetails from "./order.details.slice";
import canteen from "./canteen.slice";
import bluetoothPrinter from "./bluetooth.slice";
import thermalPrinters from "./thernam.printers.slice";

/**
 * Combined root reducer
 * Merges all slice reducers into single state tree
 */
const reducer = combineReducers({
  info,
  customer,
  cafe,
  cart,
  orders,
  orderDetails,
  canteen,
  bluetoothPrinter,
  thermalPrinters,
});
/**
 * Configured Redux store instance
 * Exports default store with thunk middleware
 */
export default configureStore({
  reducer,
  middleware: () => new Tuple(thunk),
});

